document.addEventListener("DOMContentLoaded", function () {
  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function getSelectedVariant(productRoot) {
    const selectedScript = productRoot.querySelector("script[data-selected-variant]");
    if (!selectedScript) return null;

    try {
      return JSON.parse(selectedScript.textContent);
    } catch (e) {
      return null;
    }
  }

  function renderVariantLine(productRoot) {
    const sectionId = productRoot.getAttribute("data-section-id");
    const productId = productRoot.getAttribute("data-product-id");
    if (!sectionId || !productId) return;

    const lineEl = document.getElementById(`VariantFitline-${sectionId}-${productId}`);
    const dataEl = document.getElementById(`VariantFitData-${sectionId}-${productId}`);
    if (!lineEl || !dataEl) return;

    let variantData;
    try {
      variantData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const selectedVariant = getSelectedVariant(productRoot);
    const variantId = selectedVariant?.id;

    if (!variantId || !variantData[variantId]) {
      lineEl.hidden = true;
      return;
    }

    const v = variantData[variantId];

    const topParts = [];
    if (v.model_height || v.model_wears) {
      const modelParts = [];
      if (v.model_height) modelParts.push(`Model ${escapeHtml(v.model_height)}`);
      if (v.model_wears) modelParts.push(`wears ${escapeHtml(v.model_wears)}`);
      if (modelParts.length) topParts.push(modelParts.join(" "));
    }

    const bottomParts = [];
    if (v.chest_p2p) bottomParts.push(`Chest ${escapeHtml(v.chest_p2p)}`);
    if (v.length_top_down) bottomParts.push(`Length ${escapeHtml(v.length_top_down)}`);
    if (v.shrink_note) bottomParts.push(escapeHtml(v.shrink_note));

    lineEl.innerHTML = `
      ${topParts.length ? `<div class="variant-fitline__top">${topParts.join(" — ")}</div>` : ""}
      ${bottomParts.length ? `<div class="variant-fitline__bottom">${bottomParts.join(" ")}</div>` : ""}
    `;

    lineEl.hidden = !(topParts.length || bottomParts.length);
  }

  function init() {
    document
      .querySelectorAll("product-info[data-section-id][data-product-id]")
      .forEach((productRoot) => {
        const sectionId = productRoot.getAttribute("data-section-id");
        const productId = productRoot.getAttribute("data-product-id");
        const lineEl = document.getElementById(`VariantFitline-${sectionId}-${productId}`);

        let userHasExplicitlyClickedSize = false;

        if (lineEl) {
          lineEl.hidden = true;
        }

        function showAfterExplicitSelection() {
          renderVariantLine(productRoot);
          if (lineEl) lineEl.hidden = false;
        }

        productRoot.addEventListener("click", function (e) {
          const sizeLabel = e.target.closest(
            '.globo-swatch-product-detail label, variant-selects label'
          );
          const sizeButton = e.target.closest(
            '.globo-swatch-product-detail button, variant-selects button'
          );

          if (sizeLabel || sizeButton) {
            userHasExplicitlyClickedSize = true;
            setTimeout(showAfterExplicitSelection, 100);
          }
        });

        productRoot.addEventListener("change", function () {
          if (!userHasExplicitlyClickedSize) return;
          setTimeout(showAfterExplicitSelection, 50);
        });

        document.addEventListener("variant:change", function () {
          if (!userHasExplicitlyClickedSize) return;
          showAfterExplicitSelection();
        });
      });
  }

  init();
});